{
	"ariaNoPreviewAvailable": "no preview available",
	"ariaOpenProject": "Open Project {{name}}",
	"ariaProjectEntry": "Project Entry",
	"ariaProjectOptions": "Project Options {{name}}",
	"ariaProjectThumbnailMenu": "Project Thumbnail Menu",
	"catalogChangeTitle": "{{productName}} is changing how its project catalogue is stored",
	"catalogChangeMessage": "If you have an issue opening this project, please delete this project inside {{productName}}, then reimport your project folder. Your editing histories will be recovered automatically.",
	"deleteProject": "Delete Project",
	"editProjectDate": "Edit Project Date",
	"rename": "Rename",
	"sampleProject": "Sample Project",
	"photoCount_one": "{{count}} photo",
	"photoCount_other": "{{count}} photos"
}
